/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".callout_9366f74f .ms-Suggestions-itemButton{padding:0px;border:none}.callout_9366f74f .ms-Suggestions{width:300px}\n" }]);
export var callout = "callout_9366f74f";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/FloatingPicker/BaseFloatingPicker.scss.js
// module id = 811
// module chunks = 0